import React from 'react';

const SvgWarning = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.96 1.72c.48-.8 1.627-.8 2.107 0L23.84 20.387c.453.826-.133 1.84-1.013 1.813H1.253c-.96 0-1.546-1.013-1.066-1.813zM12 17.041c-.435 0-.794.127-1.076.38-.283.253-.424.579-.424.979s.141.724.424.97c.282.248.64.371 1.076.371.447 0 .809-.123 1.085-.37.277-.247.415-.571.415-.971s-.138-.726-.415-.98c-.276-.252-.638-.379-1.085-.379zM13.306 7h-2.594v8.753h2.594V7z"
}));

export default SvgWarning;